import { useState, useCallback } from "react";
import apiClient from "utils/apiClient";

const API_BASE = "/identity-service/api/v1/auth/recovery";

export function usePasswordRecovery() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successData, setSuccessData] = useState(null);

  const startRecovery = useCallback(async ({ usernameOrEmail, lastName, dateOfBirth }) => {
    setLoading(true);
    setError(null);
    
    let formattedDob = null;
    if (dateOfBirth) {
      const d = new Date(dateOfBirth);
      const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
      const dd = String(d.getUTCDate()).padStart(2, '0');
      const yyyy = d.getUTCFullYear();
      
      formattedDob = `${mm}-${dd}-${yyyy}`;
    }

    console.log("DATA SENT → startRecovery:", { usernameOrEmail, lastName, dateOfBirth });

    const payload = {
      ...(usernameOrEmail ? { usernameOrEmail: usernameOrEmail.trim() } : {}),
      lastName: lastName ? lastName.trim() : null,
      dateOfBirth: formattedDob
    };
    try {
      const { data } = await apiClient.post(`${API_BASE}/start` , payload);
      setSuccessData(data);
      return data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to start recovery";
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const startRecoveryCode = useCallback(async ({ identifier }) => {
    setLoading(true);
    setError(null);
    setSuccessData(null);

    try {
      const { data } = await apiClient.post(`${API_BASE}/code/start`, {
        identifier: identifier?.trim(),
      });
      setSuccessData(data);
      return data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to send verification code";
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const verifyAnswers = useCallback(async ({ recoveryId, answers }) => {
    setLoading(true);
    setError(null);
    setSuccessData(null);

    console.log("DATA SENT → verifyAnswers:", { recoveryId, answers });

    try {
      const { data } = await apiClient.post(`${API_BASE}/verify`, {
        recoveryId,
        answers,
      });
      setSuccessData(data);
      return data;
    } catch (err) {
      setError(err.response?.data?.message || "Failed to verify answers");
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const verifyRecoveryCode = useCallback(async ({ otpToken, code }) => {
    setLoading(true);
    setError(null);
    setSuccessData(null);

    try {
      const { data } = await apiClient.post(`${API_BASE}/code/verify`, {
        otpToken,
        code: code?.trim(),
      });
      setSuccessData(data);
      return data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to verify code";
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

 const resetPassword = useCallback(
  async ({ resetToken, newPassword, confirmPassword }) => {
    setLoading(true);
    setError(null);
    setSuccessData(null);

    console.log("DATA SENT → resetPassword:", {
      resetToken,
      newPassword,
      confirmPassword,
    });

    try {
      const { data } = await apiClient.post(`${API_BASE}/reset`, {
        resetToken,
        newPassword,
        confirmPassword,
      });

      console.log("RESET SUCCESS:", data);
      setSuccessData(data);
      return data;
    } catch (err) {
      // THIS IS THE KEY — YOU WERE MISSING THIS LOG
      console.error("RESET FAILED — Server response:", {
        status: err.response?.status,
        data: err.response?.data,
        message: err.response?.data?.message || err.message,
      });

      setError(err.response?.data?.message || "Password reset failed");
      throw err;
    } finally {
      setLoading(false);
    }
  },
  []
);

 

  return {
    loading,
    error,
    successData,
    startRecovery,
    startRecoveryCode,
    verifyAnswers,
    verifyRecoveryCode,
    resetPassword,
  };
}
